import React from 'react';
import { Link } from "react-router-dom";
import appSyncConfig from '../AppSync';
import Ads from './Ads';

class Header extends React.Component {
	constructor(props) {
		super(props);
	}

  	render() {
		var currentUser = JSON.parse(localStorage.getItem('AuthHandsApps'));
		if(!currentUser) {
			console.log('Lost storage session');
		}
		var listTHAds = this.props.listTHAds;
		return (
			<header className="header">
				<div className="logo-container">
					<Link to="/" className="logo">
						<img src={`/img/logo.png`} alt="Therapist Management" />
					</Link>
					<div className="d-md-none toggle-sidebar-left" data-toggle-class="sidebar-left-opened" data-target="html" data-fire-event="sidebar-left-opened">
						<i className="fa fa-bars" aria-label="Toggle sidebar"></i>
					</div>
				</div>

				<div className={`adsHeader${listTHAds.length > 0 ? '' : ' ads-hide'}`}>
					<div id="carouselExampleSlidesOnlyTH" className="carousel slide" data-ride="carousel">
						<div className="carousel-inner" role="listbox">
							{listTHAds.map((adv, i) => {
								return (<Ads adv={adv} i={i} key={i} />)
							})}
						</div>
					</div>
				</div>

				<div className="header-right">
					<span className="separator"></span>

					<div id="userbox" className="userbox">
						<a href="#" data-toggle="dropdown">
							<figure className="profile-picture">
								<img src={`/img/doctor.png`} alt={currentUser.name} className="rounded-circle" data-lock-picture={`/img/doctor.png`} />
							</figure>
							<div className="profile-info" data-lock-name={currentUser.name} data-lock-email={currentUser.email}>
								<span className="name">{currentUser.name}</span>
							</div>
							<i className="fa custom-caret"></i>
						</a>
						<div className="dropdown-menu">
							<ul className="list-unstyled mb-2">
								<li className="divider"></li>
								<li>
									<Link role="menuitem" tabIndex="-1" to="/user/profile"><i className="fa fa-user"></i> My Profile</Link>
								</li>
								<li>
									<Link role="menuitem" tabIndex="-1" to="/user/change_pwd"><i className="fa fa-lock"></i> Change Password</Link>
								</li>
								<li>
									<Link role="menuitem" tabIndex="-1" to="/user/signout"><i className="fa fa-power-off"></i> Sign out</Link>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</header>
      	);
    }
}

export default Header;
